import { Saga } from 'redux-saga'
import { all, AllEffect, call, ForkEffect, spawn } from 'redux-saga/effects'

type SetupSagaSpawns = (saga: Saga) => ForkEffect<void>

/**
 * https://redux-saga.js.org/docs/advanced/RootSaga.html
 */
const makeRootSaga = (sagas: Saga[]) =>
  function* rootSaga(): Generator<AllEffect<ForkEffect>> {
    /**
     * Setup sagas to automatically restart on error.
     * Log any errors to the console.
     */
    const setupSagaSpawns: SetupSagaSpawns = (saga) =>
      spawn(function* spawnSaga() {
        while (true) {
          try {
            yield call(saga)
            break
          } catch (e) {
            console.log(e)
          }
        }
      })

    yield all(sagas.map(setupSagaSpawns))
  }

export default makeRootSaga
